const API = (method, endpoint, data, token) => {



  let url = process.env.REACT_APP_API_HOST + '/api/' + endpoint;
  const options = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  };

  // get the token from cookies if available

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }
  
  

  if(method === "GET" && data) {
    const queryParams = new URLSearchParams(data).toString();
    url += '?' + queryParams;
  } else if (data) {
    options.body = JSON.stringify(data);
  }

  //console.log("API Call:", method, url, data, options.headers);

  //if too many errors occur, log the user out

  let errorCount = 0;
  //load error count from localStorage
  const storedErrorCount = localStorage.getItem("apiErrorCount");
  if (storedErrorCount) {
    errorCount = parseInt(storedErrorCount, 10);
  }

  const maxErrors = 25;
  
  return fetch(url, options)
    .then(response => {
      if (!response.ok) {
        if (errorCount > 0) {
          errorCount = 0;
          localStorage.setItem("apiErrorCount", errorCount);
        }

        if (response.body) {
          // If the response has a body, parse it to get the error message
          return response.json().then(err => {
            const e = new Error(err.message || response.statusText);
            e.errors = err.errors;
            e.status = response.status;
            throw e;
          });

        }
        errorCount++;
        // save error count to localStorage
        localStorage.setItem("apiErrorCount", errorCount);
        console.error("API Error Count:", errorCount);
        if (errorCount >= maxErrors) {
          // Log the user out if too many errors occur
          console.error("Too many errors occurred. Logging out...");

          localStorage.removeItem("user");
          window.location.href = "/login";
        }
        throw new Error(response.statusText);

      }
      return response.json();
    })
    .then(
      data => ({ response: data, error: null })
    )
    .catch(error => {
      const msg = (error && (error.message || String(error))).toLowerCase();
      const isConnectionRefused =
        msg.includes('connection refused') ||
        msg.includes('net::err_connection_refused') ||
        msg.includes('failed to fetch') ||
        msg.includes('networkerror') ||
        msg.includes('network error');

      if (isConnectionRefused) {
        try { localStorage.removeItem('user'); } catch (_) {}
      }

      return { response: null, error: error.message, errors: error.errors, status: error.status };
    });

}

export { API };